import { useMutation } from "react-query";
import dropdownService from "../services/dropdownService";

const useUserAddOrEditMutation = (onData) => {
  return useMutation(dropdownService.userAddorEdit, {
    onSuccess: (data) => onData(data),
  });
};

const useInspectorAssignment = (onData) => {
  return useMutation(dropdownService.inspectorAssignment, {
    onSuccess: (data) => onData(data),
  });
};

const useImportCopyQuestionExclude = (onData) => {
  return useMutation(dropdownService.importCopyQuestionExclude, {
    onSuccess: (data) => onData(data),
  });
};

const dropdownQueries = {
    useUserAddOrEditMutation,
    useInspectorAssignment,
    useImportCopyQuestionExclude
};

export default dropdownQueries;
